export const ComboProductListColConfig = [
  {
    name_of_db_column: 'productId',
    label_of_column: 'Combo ID',
    order_of_column: 1,
  },
  {
    name_of_db_column: 'productName',
    label_of_column: 'Combo Name',
    order_of_column: 2,
  },
  {
    name_of_db_column: 'comboStatus',
    label_of_column: 'Status',
    order_of_column: 3,
    filterVariant: 'string',
  },
   {
    name_of_db_column: 'status',
    label_of_column: 'Availability',
    order_of_column: 4,
  },
  {
    name_of_db_column: 'segmentCount',
    label_of_column: 'Segment Count',
    order_of_column: 5,
    filterVariant: 'long',
  },
]
